/* eslint-disable no-unused-vars */
import editIcon from "assets/pictures/Icon material-edit.svg";
import addIcon from "assets/pictures/Icon-ionic-ios-add.svg";
import { Fragment, useState, useEffect } from "react";
import AddressQuery from "./AddressQuery";
import DefaultAddressQuery from "./DefaultAddressQuery";
import EditAddress from "./EditAddress";
import AddAddress from "./AddAddress";

const AddressList = ({ idState }) => {
  const { data: addressList } = AddressQuery(); // All addresses
  const { data: defaultAddress } = DefaultAddressQuery(); // Default address
  const [show, setShow] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [id, setId] = useState(null);

  // Initialize selectedId based on idState
  const [selectedId, setSelectedId] = Array.isArray(idState) ? idState : [id, setId];

  // State to track the selected address ID
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const handleAdd = () => {
    setShowAddressModal(true);
  };

  const handleEdit = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  const selectAddress = (addressId) => {
    setSelectedAddressId(addressId);
    localStorage.setItem("address", JSON.stringify(addressId));
  };

  // Ensure addressList is an array
  const addresses = Array.isArray(addressList) ? addressList : [];

  // Automatically select the default address when addressList or defaultAddress changes
  useEffect(() => {
    if (addresses.length > 0) {
      let addressToSelect = null;

      // Prioritize default address from DefaultAddressQuery
      if (defaultAddress?.id && addresses.find((addr) => addr.id === defaultAddress.id)) {
        addressToSelect = defaultAddress.id;
      } else {
        // Fallback to the first address if no default is found
        addressToSelect = addresses[0].id;
      }

      // Select the address and update state
      selectAddress(addressToSelect);
    }
  }, [addresses, defaultAddress]);

  return (
    <Fragment>
      <div className="address-section d-flex justify-content-between align-items-center">
        <h3>Saved Address</h3>
        <button onClick={handleAdd} className="btn btn-primary">
          <span>
            <img
              style={{ width: "12px", height: "12px", marginRight: "5px" }}
              src={addIcon}
              alt="Add"
            />
            Add new address
          </span>
        </button>
      </div>

      <div className="address-edit-scroll-wrapper">
        <div className="address-edit-section d-flex flex-nowrap">
          {addresses.length > 0 ? (
            <Fragment>
              {addresses.map((address, idx) => {
                const item = JSON.parse(address?.address || "{}");
                return (
                  <div className="address-card-wrapper" key={address.id}>
                    <label
                      htmlFor={`selectAddress${address.id}`}
                      className="address-card-label w-100"
                    >
                      <input
                        name="plan"
                        className="radio"
                        id={`selectAddress${address.id}`}
                        type="radio"
                        value={address.id}
                        checked={selectedAddressId === address.id}
                        onChange={() => selectAddress(address.id)}
                      />
                      <div className="card-address mt-4 mb-5">
                        <div className="card-address-edit d-flex justify-content-between align-items-center">
                          <h5 className="mb-0">{address?.title || "N/A"}</h5>
                          <button
                            className="btn p-0"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleEdit(address.id);
                            }}
                          >
                            <img src={editIcon} alt="Edit" />
                          </button>
                        </div>
                        <div className="mt-3">
                          <h5>
                            {address?.first_name || ""} {address?.last_name || ""}
                            <br />
                            {item?.address || "N/A"}, <br />
                            {item?.city || "N/A"}, {item?.state || "N/A"}, <br />
                            {item?.country || "N/A"}, {item?.zip || "N/A"}
                          </h5>
                        </div>
                      </div>
                    </label>
                  </div>
                );
              })}
            </Fragment>
          ) : (
            <p className="text-center my-3">No Address Found</p>
          )}
        </div>
      </div>
      <AddAddress modelState={[showAddressModal, setShowAddressModal]} />
      <EditAddress modelState={[show, setShow]} id={selectedId} />
    </Fragment>
  );
};

export default AddressList;